var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.img)?_c('div',{staticClass:"blockquote__photo"},[(_vm.isStippleImg)?_c('stipple-img',{attrs:{"invertColor":_vm.invertColor,"imgOriginal":_vm.img}}):_c('img',{attrs:{"src":require(`@/${_vm.img}`),"alt":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }